import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "main-contents"
}
const _hoisted_2 = { key: 5 }

import PublicSolicitation from "./PublicSolicitation.vue";
import Applied from "./Applied.vue";
import MyPage from "./MyPage.vue";
import Footer from "./Footer.vue";
import { onMounted, ref } from "vue";
import { ProjectStore } from "../store/ProjectStore";
import RegistModal from "./RegistModal.vue";
import { UserInfoStore } from "../store/UserInfoStore";
import { WITHDRAWN } from "../consts/common";
import Withdrawn from "./Withdrawn.vue";
import Favorite from "./Favorite.vue";
import { signIn } from "../services/UserInfoService";
import router from "../router";
// eslint-disable-next-line @typescript-eslint/no-explicit-any

export default /*@__PURE__*/_defineComponent({
  __name: 'Home',
  setup(__props) {

let url: any = "";
const projectStore = ProjectStore();
const userInfoStore = UserInfoStore();
const showModal = ref(false);

onMounted(async () => {
  window.addEventListener("popstate", function () {
    if (userInfoStore.isRegistFromProjectDetail.show) {
      userInfoStore.setIsRegistFromProjectDetail({
        show: false,
        title: "",
        mediaType: -1,
      });
      router.push("/project-detail");
    }
  });

  // liff起動時にtoken更新
  await signIn();
  await userInfoStore
    .getUserDetail()
    .then(() => {
      if (!userInfoStore.userDetail.id) {
        showModal.value = true;
        return;
      } else {
        showModal.value = false;
      }
      if (
        userInfoStore.userDetail.user_state != WITHDRAWN &&
        projectStore.notification.total < 0
      ) {
        projectStore.getNotification();
      }
      if (!userInfoStore.userSnsInfo.length) {
        userInfoStore.getUserSnsAccount();
      }
      if (!userInfoStore.bankInfo.id) {
        userInfoStore.getBankInfo();
      }
      if (userInfoStore.addressInfo.id < 0) {
        userInfoStore.getAddressInfo();
      }
        const url_string = window.location.href;
  // 文字列としてのURLをURLオブジェクトに変換する。
  url = new URL(url_string).search;
  // statusがpathに入っている場合はstatusも入れる
  if (projectStore.selectedTab >= 0) {
    return;
  } else if (url.match(/status/)) {
    const applied = url.split("?selectedTitleId=1&status=");
    projectStore.setSelectedStatus(+applied[1]);
    projectStore.setSelectedTab(1);
  } else if (url.match(/selectedTitleId/)) {
    const result = url.split("?selectedTitleId=");
    projectStore.setSelectedTab(+result[1]);
    // 応募済案件詳細
  } else if (url.match(/projectId/)) {
    // 退会済の場合は案件詳細は表示しない
    if (userInfoStore.userDetail.user_state == WITHDRAWN) return;
    const result = url.split("?projectId=");
    // lineの通知のurlから来た場合は応募済案件詳細に遷移する
    projectStore.setSelectedId(+result[1]);
    router.push("/applied-project-detail");
    projectStore.setSelectedTab(1);
    document.title = "OMOT Influencer";
  }  else if (url.match(/recommendationProjectId/)) {
    // 退会済の場合は案件詳細は表示しない
    if (userInfoStore.userDetail.user_state == WITHDRAWN) return;
    const result = url.split("?recommendationProjectId=");
    // lineの通知のurlから来た場合は案件詳細に遷移する
    projectStore.setSelectedId(+result[1]);
    router.push("/project-detail");
    document.title = "OMOT Influencer";
    projectStore.setSelectedTab(0);
  } else if (url.match(/address/)) {
    // LINEメッセージから 住所新規登録の場合
    // 退会済の場合は案件詳細は表示しない
    if (userInfoStore.userDetail.user_state == WITHDRAWN) return;
    projectStore.setSelectedTab(2);
    router.push("/address");
  } else {
    projectStore.setSelectedTab(0);
  }
    })
    .catch(() => {
      showModal.value = true;
      return;
    });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!showModal.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_unref(userInfoStore).userDetail.user_state == _unref(WITHDRAWN))
            ? (_openBlock(), _createBlock(Withdrawn, { key: 0 }))
            : _createCommentVNode("v-if", true),
          _createCommentVNode(" 公募案件 "),
          (
        _unref(projectStore).selectedTab == 0 &&
        !showModal.value &&
        _unref(userInfoStore).userDetail.user_state != _unref(WITHDRAWN) &&
        _unref(userInfoStore).userDetail.id
      )
            ? (_openBlock(), _createBlock(PublicSolicitation, { key: 1 }))
            : (
        _unref(projectStore).selectedTab == 3 &&
        !showModal.value &&
        _unref(userInfoStore).userDetail.user_state != _unref(WITHDRAWN) &&
        _unref(userInfoStore).userDetail.id
      )
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createCommentVNode("お気に入り"),
                  _createVNode(Favorite)
                ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
              : (
        _unref(projectStore).selectedTab == 1 &&
        !showModal.value &&
        _unref(userInfoStore).userDetail.user_state != _unref(WITHDRAWN) &&
        _unref(userInfoStore).userDetail.id
      )
                ? (_openBlock(), _createBlock(Applied, { key: 3 }))
                : (
        _unref(projectStore).selectedTab == 2 &&
        !showModal.value &&
        _unref(userInfoStore).userDetail.user_state != _unref(WITHDRAWN) &&
        _unref(userInfoStore).userDetail.id
      )
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 4 }, [
                      _createCommentVNode(" マイページ "),
                      _createVNode(MyPage)
                    ], 2112 /* STABLE_FRAGMENT, DEV_ROOT_FRAGMENT */))
                  : (_openBlock(), _createElementBlock("div", _hoisted_2))
        ]))
      : _createCommentVNode("v-if", true),
    (!showModal.value || _unref(userInfoStore).userDetail.user_state != _unref(WITHDRAWN))
      ? (_openBlock(), _createBlock(Footer, { key: 1 }))
      : _createCommentVNode("v-if", true),
    _createVNode(RegistModal, {
      modelValue: showModal.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showModal).value = $event))
    }, null, 8 /* PROPS */, ["modelValue"])
  ], 64 /* STABLE_FRAGMENT */))
}
}

})